import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { useTranslation } from '@/src/i18n';
import Link from '../../atoms/Link/Link';

import { getCardFullName } from '../../utils';

/* JS styling */

const ListContainer = styled(Box)(
  ({ theme }) => css`
    margin-top: ${theme.spacing(5)};
    ul {
      column-count: 1;
      column-gap: ${theme.spacing(3)};
    }
    ul li {
      break-inside: avoid-column; // avoid to break a li into 2 columns
    }
    a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
        color: ${theme.palette.primary.main};
      }
    }

    ${theme.breakpoints.up('sm')} {
      ul {
        column-count: 2;
      }
    }
    ${theme.breakpoints.up('lg')} {
      ul {
        column-count: 3;
      }
    }
  `,
);

/* Component */

type Props = {
  title: string;
  items: any[];
};

const LinkUrl = ({ item, t }) => {
  const fullName = getCardFullName(t, item?.card) || item?.name || '';
  return (
    <Typography
      variant="body1"
      component="h2"
      sx={{ textTransform: 'capitalize' }}
    >
      <Link href={item.url} prefetch={false} legacyBehavior>
        {fullName}
      </Link>
    </Typography>
  );
};

const InventorySection = ({ title, items }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h2" component="h1" color="primary">
        {t(title)}
      </Typography>
      <ListContainer>
        <ul>
          {items.map((item, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`directory-drug-${idx}`}>
              <LinkUrl item={item} t={t} />
            </li>
          ))}
        </ul>
      </ListContainer>
    </Box>
  );
};
export default InventorySection;
